import {
  SEARCH_INPUT_CHANGED,
  SEARCH_RESULTS,
  POINTER_INSIDE_NAV_BOX,
  SHOW_SEARCH_RESULTS,
  NAV_INDEX_CHANGED,
  ITEM_SELECTED
} from './search-box-consts';

const initialState = {
  searchResults: [],
  searchWord: null,
  bPointerInsideNavBox: false,
  bShowSearchResults: false,
  nNavIndex: -1,
  bDataIsLoading: false
};

export default function(state,action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type){
    case SEARCH_INPUT_CHANGED:
      return {...state, searchWord: action.payload.searchWord, bDataIsLoading: action.payload.bDataIsLoading};
    case SEARCH_RESULTS:
      return {...state, searchResults: action.payload.searchResults, bDataIsLoading: action.payload.bDataIsLoading};
    case POINTER_INSIDE_NAV_BOX:
      return {...state, bPointerInsideNavBox: action.payload.bPointerInsideNavBox};
    case SHOW_SEARCH_RESULTS:
      return {...state, bShowSearchResults: action.payload.bShowSearchResults};
    case NAV_INDEX_CHANGED:
      return {...state, nNavIndex: action.payload.nNavIndex};
    case ITEM_SELECTED:
      return {...state, bShowSearchResults: false, nNavIndex: action.payload.nNavIndex};
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** app/components/search-box/state/search-box-reducer.js
 **/